<template>
  <!-- Solo existe en el DOM cuando hay un problema: mientras los procesos CORE
       esten al dia el navbar queda igual que siempre. -->
  <div v-if="hayProblema" class="health-core-alert" @click="mostrarDetalle" :title="$t('revisar_procesos_core')">
    <i class="fas fa-heartbeat"></i>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import registroLogService from '@/api/registroLogService';
import utilsService from '@/api/utilsService';

// Cada cuanto se vuelve a consultar el estado. 60s: la tolerancia mas corta
// configurada en el backend es de 5 minutos, no tiene sentido preguntar mas
// seguido.
const INTERVALO_MS = 60000;

export default {
  name: 'HealthProcesosCoreAlert',

  data() {
    return {
      healthCore: null,
      timer: null,
    };
  },

  computed: {
    // Mismos roles que la ruta log-process: al resto de los perfiles no les
    // sirve el aviso ni pueden entrar a revisarlo.
    puedeVer() {
      return ['admin', 'visita'].includes(utilsService.getRol());
    },

    hayProblema() {
      return this.puedeVer && !!this.healthCore && !this.healthCore.ok;
    },

    procesosConProblema() {
      if (!this.healthCore || !this.healthCore.procesos) return [];
      return this.healthCore.procesos.filter(p => !p.ok);
    },
  },

  mounted() {
    if (!this.puedeVer) return;
    this.cargar();
    this.timer = setInterval(this.cargar, INTERVALO_MS);
  },

  beforeDestroy() {
    // Sin esto el polling sobrevive al componente y sigue pegandole a la API
    // despues de cerrar sesion.
    if (this.timer) clearInterval(this.timer);
  },

  methods: {
    async cargar() {
      try {
        this.healthCore = await registroLogService.getHealthProcesosCore();
      } catch (e) {
        // Si el chequeo no responde no se alerta: sin respuesta no hay
        // informacion para afirmar que los procesos esten caidos, y un fallo
        // de este endpoint no puede ensuciar el navbar de toda la app.
        this.healthCore = null;
      }
    },

    // Los nombres salen de la base (dbo.Diccionarios) y se inyectan como HTML
    // en el Swal, asi que se escapan.
    escapar(texto) {
      const div = document.createElement('div');
      div.textContent = texto == null ? '' : String(texto);
      return div.innerHTML;
    },

    mostrarDetalle() {
      const filas = this.procesosConProblema.map((p) => {
        const nombre = this.escapar(p.nombre || `IdProceso ${p.idProceso}`);
        const detalle = p.minutosDesdeUltimaEjecucion != null
          ? `${p.minutosDesdeUltimaEjecucion} min ${this.$t('sin_reportar')} (${this.$t('tolerancia')} ${p.toleranciaMinutos} min)`
          : this.$t('sin_ejecuciones');
        return `<tr>
                  <td style="text-align:left;padding:4px 8px;font-weight:600;">${nombre}</td>
                  <td style="text-align:right;padding:4px 8px;color:#dc3545;">${this.escapar(detalle)}</td>
                </tr>`;
      }).join('');

      Swal.fire({
        icon: 'error',
        title: this.$t('revisar_procesos_core'),
        html: `<table style="width:100%;font-size:.85rem;">${filas}</table>`,
        showCancelButton: true,
        confirmButtonText: this.$t('ir_a_log_procesos'),
        cancelButtonText: this.$t('cerrar'),
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
      }).then((result) => {
        // La comprobacion de ruta evita el error NavigationDuplicated de
        // vue-router cuando ya estas parado en la vista.
        if (result.isConfirmed && this.$route.name !== 'log-process') {
          this.$router.push({ name: 'log-process' });
        }
      });
    },
  },
};
</script>

<style scoped>
.health-core-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ff5a5f;
  font-size: 1.25rem;
  padding: 0 12px;
  margin-bottom: 10px; /* alinea con el select de idioma, que trae margin-bottom */
  animation: health-core-latido 1.4s ease-in-out infinite;
}

.health-core-alert:hover {
  color: #fff;
}

@keyframes health-core-latido {
  0%   { transform: scale(1);    opacity: 1;   }
  50%  { transform: scale(1.28); opacity: .65; }
  100% { transform: scale(1);    opacity: 1;   }
}

/* Respeta la preferencia del sistema: sin movimiento el icono se sigue
   distinguiendo por el color. */
@media (prefers-reduced-motion: reduce) {
  .health-core-alert {
    animation: none;
  }
}
</style>
